export default "__VITE_ASSET__CLTzo7XA__"